
import Empty from "@/components/Empty.vue";
import {
  state,
  alternativesIds,
  getAlternatives,
  getImagePath,
  getFilteredItemsBy,
  switchToView,
} from "@/store";
import { defineComponent, computed } from "vue";
export default defineComponent({
  setup() {
    return {
      alternativesIds: computed(() => alternativesIds()),
      getAlternatives: computed(() => getAlternatives()),
      switchToView: function (routeName: string) {
        return switchToView(routeName);
      },
      getImagePath,
      getFilteredItemsBy,
      state,
    };
  },
  components: {
    Empty,
  },
});
